import { isEmptyArray, isEmptyString, vySerialize, withNewOptionalValue } from '@vy/utils';
import { useContracts } from '../../../../../hooks/requests/use-contracts';
import { useTableSorting } from '../../../../../hooks/use-table-sorting';
import { useFiltersParam } from '../../plans-page-hooks/use-filters-param';
import { useQueryInputParams } from '../../plans-page-hooks/use-query-input-param';
import { useAdditionalFiltersParam } from '../hooks/use-additional-filters-param';
import { useContractStatusesParam } from '../hooks/use-contract-statuses-param';

export function useTableContracts(page: number, pageSize: number, customerId?: string) {
  const [searchQuery] = useQueryInputParams();
  const [filters] = useFiltersParam();
  const { currentSortModel } = useTableSorting();
  const [contractStatuses] = useContractStatusesParam();
  const [additionalFilters] = useAdditionalFiltersParam();

  return useContracts({
    page,
    pageSize,
    customerId,
    search: isEmptyString(searchQuery) ? undefined : searchQuery,
    contractFilters: isEmptyArray(filters) ? undefined : vySerialize(filters),
    sort: withNewOptionalValue(currentSortModel, vySerialize),
    contractStatuses: isEmptyArray(contractStatuses) ? undefined : vySerialize(contractStatuses),
    additionalFilters: isEmptyArray(additionalFilters) ? undefined : vySerialize(additionalFilters),
  });
}
